// assets/retention_atc.js.liquid

(function () {
  // Helper: fetch cart details
  function fetchCartDetails() {
    return fetch('/cart.js').then((res) => res.json());
  }

  // Helper: fix image URL
  function cleanImageUrl(imageUrl) {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('//')) {
      return 'https:' + imageUrl;
    } else if (imageUrl.startsWith('http')) {
      return imageUrl;
    } else {
      return 'https://' + imageUrl;
    }
  }

  // Helper: decode HTML entities (e.g. &quot; -> ")
  function decodeHtmlEntities(str) {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  // Helper: get clean product name
  function getCleanProductName() {
    const h1 = document.querySelector('h1.product_name[itemprop="name"]');
    return h1 ? decodeHtmlEntities(h1.textContent.trim()) : '';
  }

  // Helper: transform product object to match payload structure
  function transformProduct(item) {
    const imageUrl = item.featured_image
      ? (item.featured_image.url
          ? cleanImageUrl(item.featured_image.url)
          : cleanImageUrl(item.featured_image))
      : '';

    return {
      Url: window.location.origin + item.url,
      Name: getCleanProductName() || item.title,
      Brand: item.vendor,
      Price: (item.price / 100).toFixed(2),
      Variant: item.variant_title,
      Currency: 'USD',
      ImageUrl: imageUrl,
      ProductId: item.product_id.toString(),
      VariantId: item.variant_id.toString(),
      Quantity: item.quantity
    };
  }

  // Helper: build payload
  function buildPayload(product, cart) {
    let imageUrl = '';
    if (product.featured_image) {
      imageUrl = cleanImageUrl(product.featured_image);
    }

    // Use clean product name
    const productName = getCleanProductName() || product.title;

    const topLevelProduct = {
      Url: window.location.href,
      Name: productName,
      Brand: product.vendor,
      Price: (product.price / 100).toFixed(2),
      Variant: product.variant_title,
      Currency: 'USD',
      ImageUrl: imageUrl,
      ProductId: product.id.toString(),
      VariantId: product.variant_id ? product.variant_id.toString() : '',
      Quantity: 1 // Default to 1 for add to cart
    };

    return {
      Url: window.location.href,
      Name: productName,
      Brand: product.vendor,
      Price: (product.price / 100).toFixed(2),
      Variant: product.variant_title,
      Currency: 'USD',
      ImageUrl: imageUrl,
      ProductId: product.id.toString(),
      VariantId: product.variant_id ? product.variant_id.toString() : '',
      Quantity: 1,
      CartUrl: window.location.origin + '/cart',
      products: [topLevelProduct, ...cart.items.map(transformProduct)],
    };
  }

  // Helper: extract product data from modal form if available
  function extractProductFromModal(button) {
    const form = button.closest('form');
    if (form && form.dataset && form.dataset.product) {
      try {
        const productData = JSON.parse(form.dataset.product);
        const variantSelect = form.querySelector('select[name="id"]');
        const variantId = variantSelect ? variantSelect.value : null;
        const variant = productData.variants.find(v => v.id.toString() === variantId) ||
                        productData.variants[0];

        productData.variant_id = variant.id;
        productData.variant_title = variant.title;
        productData.price = variant.price;

        return productData;
      } catch (e) {
        console.error('[Retention ATC] Error parsing modal product data:', e);
      }
    }
    return null;
  }

  // Helper: fetch product details from endpoint
  function fetchProductDetails(productId) {
    return fetch(`/products/${productId}.js`).then((res) => res.json());
  }

  // Main handler for Add to Cart click
  function handleAddToCartClick(e) {
    const button = e.target.closest('.add_to_cart, [name="add"][data-label="Add to Cart"], [data-narvar-button="addtocart"]');
    if (!button) return;

    let product = extractProductFromModal(button);

    let productPromise;
    if (product) {
      productPromise = Promise.resolve(product);
    } else {
      let productId = window.location.pathname.split('/products/')[1];
      if (productId && productId.includes('?')) {
        productId = productId.split('?')[0];
      }

      if (!productId) {
        console.error('[Retention ATC] Product ID not found in URL.');
        return;
      }

      console.log('[Retention ATC] Fetching product details from page for productId:', productId);
      productPromise = fetchProductDetails(productId);
    }

    productPromise
      .then((productData) => {
        fetchCartDetails()
          .then((cart) => {
            const payload = buildPayload(productData, cart);
            console.log('[Retention ATC] Final Payload:', payload);

            if (typeof geq !== 'undefined' && typeof geq.addToCart === 'function') {
              geq.addToCart(payload);
            }
          })
          .catch((error) => {
            console.error('[Retention ATC] Error fetching cart:', error);
          });
      })
      .catch((error) => {
        console.error('[Retention ATC] Error fetching product details:', error);
      });
  }

  // Initialize click listeners on Add to Cart buttons
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.add_to_cart, [name="add"][data-label="Add to Cart"], [data-narvar-button="addtocart"]');
    if (button) {
      handleAddToCartClick(e);
    }
  });

  console.log('[Retention ATC] Add to Cart tracking script loaded.');
})();
